<template>
    <div class="checkout-container">
      <div class="progress-container">
        <a-steps progress-dot :current="current">
          <a-step title="Handlevogn" description="Gjennomgå ordren din" />
          <a-step title="Betaling" description="Siste steg!" />
          <a-step title="Bekreftelse" description="Dine ordredetaljer." />
        </a-steps>
      </div>
      
      <div class="selected-restaurant">
        <h2>Valgt restaurant:</h2>
        <h3>{{ selectedRestaurant.replace("AS", "") }}</h3>
      </div> 
     
      <div class="container" id="mainContainer">
          <div id="payment-container" class="payment-container"></div>
      </div>

     
    </div>
</template>

<script>
import { CHANGED_RESTAURANT_EVENT, LOADING_EVENT } from "../../events/eventsSource";
import { mapState, mapGetters } from "vuex";
import PhoneInput from "../../components/inputs/PhoneInput.vue";
import TimeFormatter from "../../commons/TimeFormatter";
import cartStorage from "../../storage/cart";
import restaurantStorage from "../../storage/restaurants";
import NotificationModal from "../../components/modals/NotificationModal.vue";
import PickupTimeChangedConfimModal from "../../components/modals/PickupTimeChangedConfimModal.vue";
 
export default {

  inject: ["eventBus"],
  
  components: {
    PhoneInput,
    NotificationModal,
    PickupTimeChangedConfimModal
  },
  computed: {
    ...mapState({
      selectedRestaurant: state => state.app.selectedRestaurant
    }),
    ...mapGetters({

    })
  },
  data() {
    return {
      netsCheckout : null,
      current : 1,
      isLoading : false,
    }
  },
  
  methods: {
    
    handleBtnRefresh() {

      if(this.netsCheckout !== null) {
        this.netsCheckout.cleanup();
      }
      location.reload();

    },

    handlePaymentCheckoutBtnClickedEvent(res) {
      //
      //loading
      //
      console.log('pay-initalized')
      console.log(res);
      this.netsCheckout.send('payment-order-finalized', true);
    },

    handlePaymentCheckoutCompletedEvent(res) {
      //
      //redirect
      //
      console.log('pay-completed')
      console.log(res);

      let paymentId = res['paymentId'];
      this.$store.commit('payment/CLEAR_PAYMENT_SESSION_STATE', {});
      this.$store.commit('cart/CLEAR_CART_STATE', {});
      this.$router.push({
        name: 'checkoutaccept',
        query: { paymentId : paymentId } 
      })
    },

    initPaymentIFrame() {
      this.netsCheckout = new Dibs.Checkout(this.$store.state.payment.netsCheckoutOption);
      this.netsCheckout.on('pay-initialized', (res) => this.handlePaymentCheckoutBtnClickedEvent(res));
      this.netsCheckout.on('payment-completed', (res) => this.handlePaymentCheckoutCompletedEvent(res));
      //console.log(this.netsCheckout)
    },
  },

  
  async created () {
    console.log('Created: Load payment object from server or store')
    this.$loading(true);
    if (this.$store.state.payment.netsCheckoutOption === null) {
      //
      //Get and set current restaurant
      //
      await this.$store.dispatch("restaurants/getRestaurantsAction");

      //
      //Get payment information
      //
      let paymentId = this.$route.query.paymentId;
      let response = await this.$store.dispatch('payment/getPaymentDetailByIdAction', { paymentId : paymentId } );

      if (response !== null && Object.keys(response).length > 0) {

        this.$nextTick(() => {

          if(this.$store.state.payment.chargedAmount <= 0) {
            console.log('The payment is cancelled!');
            this.$store.commit('payment/CLEAR_PAYMENT_SESSION_STATE', {} );

            //
            //Set current restaurant
            //
            let currentRestaurantId = response.cart.restaurantId;
            
            let name = this.$store.getters['restaurants/restaurantName'](currentRestaurantId);
            let restaurant = {
              restaurantName : name,
              restaurantId : currentRestaurantId
            };
            
            this.$store.commit("restaurants/SET_CURRENT_RESTAURANT_STATE", restaurant);
            this.$store.commit("app/CHANGED_RESTAURANT_STATE", restaurant);
            this.$router.push({
              name: 'checkout'
            });
          }

          else {
            console.log('The order has been paid, redirect user to Order Confirmation...');
            //
            //Clear cart state and clear payment state
            //
            this.$store.commit('cart/CLEAR_CART_STATE', {});
            this.$store.commit('payment/CLEAR_PAYMENT_SESSION_STATE', {} );
            let paymentId = this.$route.query.paymentId;

            this.$router.push({
              name: 'checkoutaccept',
              query: { paymentId : paymentId } 
            });
          }
        });
      }

      else {
        this.$router.push({
              name: 'notfound'
        });
      }
    }  
    else {
      this.$nextTick(() => {
        console.log('init payment iframe from store...');
        this.initPaymentIFrame();
      })
      
    }
    this.$loading(false);
  },

  destroyed() {
    console.log('destroyed payment iframe, clear all of resources!')

    if(this.netsCheckout !== null) {
      this.netsCheckout.cleanup();
    }
  },
  
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.hidden-element {
  @media (max-width: $mobile) {
    height: 64px;
    & hr {
      border-bottom: 1px solid #c5c5c5;
      box-shadow: 0 20px 20px -20px #333;

      border: none;
      height: 43px;
      position: relative;
    }
  }
}

hr {
  @media (min-width: $mobile) {
    display: none;
  }
}

.payment-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}


.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 10px;
}

.myElementClass{
    position: absolute;
    bottom: 0;
}

.selected-restaurant{
  font-family: bebas;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 50px ;
      display: flex;
    flex-direction: column;
    align-items: center;
     @media (max-width: $tablet) {

       margin-bottom: 9px;
  }
  & h3{
        border: 1px solid #e3e3e3;
    width: 14em;
    padding: 1.5em;
    background-color: whitesmoke;
    border-radius: 8px;
     @media (max-width: $tablet) {
    width: 54%;

       padding: 4%;
  }
  }
}
.progress-container {
  margin: 5% 25%;

  @media (max-width: $mobile) {
    margin: 10px 0 0 0;
    position: relative;
    left: -16px;
  }
}
.checkout-wrapper {
  display: flex;
  justify-content: center;

  @media (max-width: $mobile) {
    flex-direction: column;
    width: auto;
  }

    @media (width: 1024px) {
    margin: 0 21px
  }
}
.checkout-container {
  margin-bottom: 60px;
  font-family: Roboto, sans-serif;
}
.header-background-image {
  background-image: url("~@/assets/images/cartview-image.jpg");
  background-size: cover;

  margin-top: 10px;
  height: 490px;
  width: 100%;
  object-fit: cover;

  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}
.header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }
}
.about-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 40px;
    width: auto;
  }
}
h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
}
.about-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0 0 0.67em 0;
  font-size: 2vw;
  margin: 0;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
}

</style>

